export const departmentOptions = [
  { value: "NBD", label: "NBD" },
  { value: "Sales", label: "Sales" },
  { value: "Assignment", label: "Assignment" },
  { value: "Care", label: "Care" },
  { value: "L&R", label: "L&R" },
  { value: "Repair", label: "Repair" },
  { value: "Care", label: "Dispatch" },
  { value: "Other", label: "Other" },
];

export const requestReasonOptions = [
  { value: "Order Correction", label: "Order Correction" },
  { value: "New Order", label: "New Order" },
  { value: "Account Correction", label: "Account Correction" },
  { value: "Order Inquiry", label: "Order Inquiry" },
  { value: "Account Inquiry", label: "Account Inquiry" },
  { value: "Other", label: "Other" },
];

export const uberRequestReasonOptions = [
  { value: "Handraise", label: "Handraise" },
  { value: "Escalation (for Callback)", label: "Escalation (for Callback)" },
  { value: "For Callback (Disconnected)", label: "For Callback (Disconnected)" }
];

export const supportDepartmentOptions = [
  { value: "Presto Back Office", label: "Presto Back Office" },
];

export const productOptions = [
  { value: "Copper Presto", label: "Copper Presto" },
  { value: "FIFA Presto", label: "FIFA Presto" },
];

export const isValidPhoneNumber = (ph_number) => {
  let phoneNumberPattern = new RegExp(/^\d([0-9 -]{0,10}\d)?$/);
  return phoneNumberPattern.test(ph_number.trim());
};

export const dashifyPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"); 
};

export const isIdenticalPhNumber = (ph_number) => {
  let phNo = ph_number.replace("-", "").replace("-", "");
  let isIdenticalPattern = new RegExp(/^\d*(\d)\1{9}\d*$/);
  return isIdenticalPattern.test(phNo.trim());
};

export const isIdenticalBtnNumber = (btn_number) => {
  let btnNo = btn_number.replace("-", "").replace("-", "");
  let isIdenticalPattern = new RegExp(/^\d*(\d)\1{5}\d*$/);
  return isIdenticalPattern.test(btnNo.trim());
};

export const isValidBtnNcid = (ncid) => {
  const ncidPattern = /^\d{6,7}$/;
  const phoneNumberPattern = new RegExp(/^\d([0-9 -]{0,10}\d)?$/);
  return (ncidPattern.test(ncid) || phoneNumberPattern.test(ncid));
};

export const errorMessages = {
  name: "Name should not be empty.",
  employeeId: "Employee ID should not be empty.",
  phone: "Phone Number should not be empty.",
  btn: "BTN/NCID should not be empty.",
  department: "Department should not be empty.",
  supportDepartment: "Support Department should not be empty.",
  reason: "Request Reason should not be empty.",
  valid_ph: "Please enter a valid phone number.",
  valid_ncid: "Please enter a valid BTN/NCID.",
  bname: "Business name should not be empty.",
  bnameLimit: "Business Name should not be greater than 100 characters.",
  queue: "Please select queue.",
  bname: "Business name should not be empty.",
  details: "Details should not be greater than 200 characters."
};

export const maxLength = {
  bnameLength: 100,
  detailLength: 200
};

export const sessionExpiredMsg = 'Your session has been expired, please refresh the page.';

export const USER_DETAIL_SESSION_KEY = 'user_session_details';
export const USER_TIME_SESSION_KEY = 'user_session_time';
export const SESSION_RESTORE_DURATION=8*60*60*1000; // 8 HOURS

export const APP_CLIENTS={
  lighthouse: "lighthouse",
  uber: "uber"
}

export const SSO_TYPE = {
  oauth: 'oauth',
  one_login: 'one_login'
};